import React, { useMemo } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import SelectionGridCst from "@components/SelectionGridCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData, ActivityV1Type } from "../types";
import { ACTIVITY_TYPES } from "../config/activityTypes";

const TypeSelectionStep: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
}) => {
  const { t } = useTranslation("wizard-activity");
  const theme = useTheme();

  const options = useMemo(
    () =>
      ACTIVITY_TYPES.map((typeDef) => ({
        key: typeDef.key,
        title: t(typeDef.titleI18nKey),
        description: t(typeDef.descriptionI18nKey),
      })),
    [t],
  );

  return (
    <Box>
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 700,
          color: theme.palette.text.primary,
          mb: 3,
        }}
      >
        {t("steps.type-selection.question")}
      </Typography>

      <SelectionGridCst
        options={options}
        selectedKey={data.type}
        onSelect={(key) => setData({ type: key as ActivityV1Type })}
      />
    </Box>
  );
};

export default TypeSelectionStep;
